import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_RESET,
} from "../../../redux/types/auth";

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        loading: true,
        message: "",
        error: "",
        success: false,
      };
    case LOGIN_SUCCESS:
      return {
        loading: false,
        message: action.payload.message || "Login successful",
        error: "",
        success: true,
      };
    case LOGIN_FAILURE:
      return {
        loading: false,
        message: "",
        error: action.payload.error || "Login failed",
        success: false,
      };
    case LOGIN_RESET:
      return initialState;
    default:
      return state;
  }
};

export default loginReducer;
